
    import '/home/ec2-user/Youlify-Design/components/flex/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["flex-demo-basic","flex-demo-align","flex-demo-gap","flex-demo-wrap","flex-demo-combination","flex-demo-debug"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/flex/index.en-US.md?type=demo')
};